import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Survey, SurveySort } from '../../models/survey.model';
import {
  SurveyStateFilters,
  SurveyRequestContext,
} from '../survey-state.model';

export const SurveyActions = createActionGroup({
  source: 'Survey',
  events: {
    /** Initialize the survey list for a given request context. Resets all state. */
    init: props<{ context: SurveyRequestContext }>(),

    /** Merge partial filter overrides and re-fetch from page 1. */
    'Set Filters': props<{ filters: Partial<SurveyStateFilters> }>(),

    /** Reset all filters back to defaults and re-fetch from page 1. */
    'Reset Filters': emptyProps(),

    /** Merge partial sort overrides and re-fetch from page 1. */
    'Set Sort': props<{ sort: SurveySort }>(),

    /** Re-fetch current page without mutating any state. */
    Reload: emptyProps(),

    /** Advance to the next page and append results. */
    'Load Next Page': emptyProps(),

    // Internal — dispatched by effects only, not from components.
    'Load Success': props<{ surveys: Survey[] }>(),
    'Load Failure': props<{ error: string }>(),
  },
});
